
import React from 'react';
import { useNavigate } from 'react-router-dom';
import type { GroupPackage1 } from './PackagesSection';
import { getGroupTourImageUrl } from '@/environments/environment';

interface PackageCardProps {
  package: GroupPackage1;
}

export const PackageCard: React.FC<PackageCardProps> = ({ package: pkg }) => {
  const navigate = useNavigate();

  const imageSrc = getGroupTourImageUrl(pkg.imageUrl);

  const handleView = () => {
    const id = (pkg as any).id || (pkg as any)._id;
    navigate(`/group-tours/details?id=${id}&location=${encodeURIComponent(pkg.tourTitle)}`);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group flex flex-col h-full">
      <div className="relative overflow-hidden">
        <img
          src={imageSrc}
          alt={pkg.tourTitle}
          className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-3 left-3">
          <span className="bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
            {pkg.category}
          </span>
        </div>
        <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm rounded-lg px-2 py-1">
          <div className="flex items-center gap-1">
            <i className="ri-star-fill text-yellow-400 text-sm"></i>
            <span className="text-sm font-medium text-gray-900">{pkg.rating}</span>
          </div>
        </div>
      </div>

      <div className="p-6 flex flex-col flex-1">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-gray-900 mb-2 line-clamp-2">
            {pkg.tourTitle}
          </h3>
          <div className="flex items-center gap-4 text-sm text-gray-600 mb-2">
            <div className="flex items-center gap-1">
              <i className="ri-map-pin-line"></i>
              <span>{pkg.inclusive && pkg.inclusive.length > 0 ? 'All Inclusive' : 'Tour'}</span>
            </div>
            <div className="flex items-center gap-1">
              <i className="ri-time-line"></i>
              <span>{pkg.destinations?.days || 'N/A'} Days</span>
            </div>
          </div>
          <p className="text-gray-600 text-sm line-clamp-2 mb-3">
            {pkg.description || 'A wonderful travel package tailored for you.'}
          </p>
        </div>

        <div className="mt-auto">
          <div className="flex items-center justify-between mb-4">
            <div>
              <div className="text-2xl font-bold text-emerald-600">
                ₹{(pkg.price?.total || 140000).toLocaleString()}
              </div>
              <div className="text-sm text-gray-500">
                {pkg.reviews || 0} reviews
              </div>
            </div>
            <div className="flex items-center gap-1 text-sm text-gray-600">
              <i className="ri-star-fill text-yellow-400"></i>
              <span>{pkg.rating || 4.5}</span>
              <span>({pkg.reviews || 0})</span>
            </div>
          </div>

          <div className="flex flex-col gap-3">
            <button
              onClick={handleView}
              className="w-full bg-emerald-600 text-white py-3 rounded-lg hover:bg-emerald-700 transition-colors duration-200 font-medium flex items-center justify-center gap-2 whitespace-nowrap"
            >
              <i className="ri-eye-line"></i>
              View
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
